module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row border-bottom"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top gray-bg",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary",
    on: {
      "click": _vm.onCollapseMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('form', {
    staticClass: "navbar-form-custom",
    attrs: {
      "role": "search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search interactions...",
      "name": "top-search",
      "id": "top-search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-top-links navbar-right"
  }, [_c('li', [_c('span', {
    staticClass: "m-r-sm text-muted welcome-message"
  }, [(!_vm.me.is_staff && !_vm.me.is_admin && !_vm.me.is_org_admin) ? _c('span', [_vm._v(_vm._s(_vm.me.company_name))]) : _vm._e(), _vm._v(" "), (_vm.me.is_staff || _vm.me.is_admin || _vm.me.is_org_admin) ? _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.selectCompanyDialogVisible = !_vm.selectCompanyDialogVisible
      }
    }
  }, [_vm._v(_vm._s(_vm.me.company_name))])]) : _vm._e()]), _vm._v(" "), (_vm.me.is_streaming) ? _c('span', {
    class: ("label label-" + (_vm.getStreamingStats().streamingClass))
  }, [_vm._v("\n              Streaming: " + _vm._s(_vm.getStreamingStats().now) + "\n              "), (_vm.getStreamingStats().growth !== 0) ? _c('i', {
    class: ("fa fa-level-" + (_vm.getStreamingStats().growthClass))
  }, [_vm._v(_vm._s(_vm.getStreamingStats().growth))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Knowledge Base",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleKnowledgeBaseClick
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "New Social Post",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleNewSocialPost
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Support"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.handleHelpClick
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-dropdown', {
    attrs: {
      "hide-on-click": false,
      "trigger": "hover",
      "placement": "bottom"
    }
  }, [_c('el-badge', {
    staticClass: "activity-badge",
    attrs: {
      "value": _vm.activities.length
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "plain": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "id": "item"
    }
  }, [_c('activities-list', {
    attrs: {
      "activities": _vm.activities
    },
    on: {
      "deleteActivity": _vm.deleteActivity
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "spacing"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover",
      "placement": "bottom",
      "show-timeout": 100
    },
    on: {
      "command": _vm.handleDropdownCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.user.avatar || _vm.user.gravatar,
      "width": "32px",
      "size": 32
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    ref: 'userdropdown',
    attrs: {
      "slot": "dropdown",
      "id": "user-dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "editProfileDialogVisible"
    }
  }, [_c('span', {
    staticClass: "fa fa-user"
  }), _vm._v(" Edit Profile\n                ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "restPasswordDialogVisible"
    }
  }, [_c('span', {
    staticClass: "fa fa-key"
  }), _vm._v("Change Password\n                ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "onLogout",
      "divided": true
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("Log out\n                ")])], 1)], 1)], 1)])])]), _vm._v(" "), (_vm.dashboardHeaderEnabled) ? _c('div', {
    staticClass: "row wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dashboardTitle))]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumbs), function(breadcrumb) {
    return _c('li', {
      key: breadcrumb
    }, [_vm._v(_vm._s(breadcrumb))])
  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.restPasswordDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "Change Password",
      "visible": _vm.restPasswordDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.restPasswordDialogVisible = $event
      }
    }
  }, [_c('PasswordOnlyResetForm', {
    attrs: {
      "requireOldPassword": true
    },
    on: {
      "togglePasswordDialog": _vm.handleToggleDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Profile",
      "visible": _vm.editProfileDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.editProfileDialogVisible = $event
      }
    }
  }, [_c('edit-profile-form', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Select Company",
      "visible": _vm.selectCompanyDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectCompanyDialogVisible = $event
      }
    }
  }, [_c('company-selector', {
    attrs: {
      "companies": _vm.companies
    },
    on: {
      "onSwitchCompany": function($event) {
        return _vm.onSwitchCompany($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e2900ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/app/AppHeader.vue
// module id = 3275
// module chunks = 3